import { AUTH_MODES, getAuthMode } from '@xstudios/xapp-auth/config/authMode'
import { useAllauthSessionAuthStore } from '@xstudios/xapp-auth/stores/allauthSessionAuthStore'
import { useFastApiTokenAuthStore } from '@xstudios/xapp-auth/stores/fastApiTokenAuthStore'
import { useGoogleJwtAuthStore } from '@xstudios/xapp-auth/stores/googleJwtAuthStore'

export function useRuntimeAuthStore() {
  const mode = getAuthMode()
  if (mode === AUTH_MODES.ALLAUTH) return useAllauthSessionAuthStore()
  if (mode === AUTH_MODES.FASTAPI) return useFastApiTokenAuthStore()
  return useGoogleJwtAuthStore()
}
